import { useCallback, useState } from 'react'

import { TextLink } from '@circlefin/components'
import { useController } from '@circlefin/form'
import { createFormInput } from '@circlefin/form/Form.Input'
import useTranslation from 'next-translate/useTranslation'

export interface LineTwoProps {
  /**
   * Field name.
   */
  name: string
  /**
   * Label.
   */
  label?: string
  /**
   * Label for CTA button.
   */
  ctaLabel?: string
  /**
   * ClassName.
   */
  className?: string
  /**
   * Disabled?
   */
  disabled?: boolean
}

const Input = createFormInput()

export const LineTwo: React.FC<LineTwoProps> = ({ ctaLabel, ...props }) => {
  const { t } = useTranslation('forms')
  const { field } = useController({
    name: props.name,
  })
  const [showAddressLine2, setShowAddressLine2] = useState(false)

  const addAddressLine2 = useCallback(() => {
    setShowAddressLine2(true)
  }, [])

  return Boolean(field.value) || showAddressLine2 ? (
    <Input
      className="w-full"
      label={props.label ?? t('input.common.addressLineTwo.label')}
      {...props}
    />
  ) : (
    <TextLink
      className="rounded-sm focus-within:focus-ring"
      disabled={props.disabled}
      name={props.name}
      onClick={addAddressLine2}
      variant="primary"
    >
      {ctaLabel ?? t('input.common.addressLineTwo.cta')}
    </TextLink>
  )
}
